export default __webpack_public_path__ + "static/media/qualys.30f4b21c.png";